// external libraries
import { useMemo } from 'react';

// types
import type { EmployeeDutyData } from 'RestAPIs/cost-centers/employees/types';
import type { OpenRequestResponse } from 'RestAPIs/roster/open-requests/types';
import type { RosterPlanFilterSelection } from '../RosterPlan.types';

// utils
import { applyRosterPlanFilters } from '../utils/applyRosterPlanFilters';

export type UseFilteredRosterDataProps = {
  employees?: EmployeeDutyData[];
  openRequests?: OpenRequestResponse[];
  appliedFilters: RosterPlanFilterSelection[];
};

const useFilteredRosterData = ({
  employees,
  openRequests,
  appliedFilters
}: UseFilteredRosterDataProps) =>
  /**
   * Explicit `useMemo` and no React Compiler directive, against the wider repo's habit: this hook's
   * return identity is load bearing (it feeds `rows` on a DataGridPro), and the folder keeps an
   * explicit guarantee there rather than the compiler's best effort. Reasoning in README.md,
   * "Decisions".
   */
  useMemo(
    () =>
      applyRosterPlanFilters({
        employees,
        openRequests,
        appliedFilters
      }),
    [employees, openRequests, appliedFilters]
  );

export default useFilteredRosterData;
